import { Platform } from 'react-native';
import { withSpring } from 'react-native-reanimated';
import {
  SPRING_CONFIG,
} from './ImageViewerConstants';
import type { IImageViewerSharedValues } from './useImageViewerSharedValues';
import type { IPaneSlot } from './usePaneSlots';

export const handleWebHistory = (
  visible: boolean,
  isClosingProgrammatically: { current: boolean }
) => {
  if (Platform.OS === 'web' && visible && window.history.state?.imageViewer) {
    isClosingProgrammatically.current = true;
    window.history.back();
    setTimeout(() => {
      isClosingProgrammatically.current = false;
    }, 50);
  }
};

// Reset zoom and pan transforms on a pane slot. Worklet-safe so callers can
// invoke this from gesture worklets after a swipe commit (the previously-active
// slot retains its zoom state until reset).
export const resetPaneTransforms = (slot: IPaneSlot) => {
  'worklet';
  slot.scale.value = 1;
  slot.translateX.value = 0;
  slot.translateY.value = 0;
  slot.baseScale.value = 1;
  slot.lastScale.value = 1;
  slot.lastTranslateX.value = 0;
  slot.lastTranslateY.value = 0;
};

// Tap-inside-image check during the open morph (uses the morph rect rather
// than per-pane geometry, since the morph overlay is the only visible image
// while opening/closing).
export const checkTapInsideMorph = (
  event: any,
  sv: IImageViewerSharedValues,
  activePane: IPaneSlot
) => {
  'worklet';
  const cX = sv.animLeft.value + sv.animWidth.value / 2;
  const cY = sv.animTop.value + sv.animHeight.value / 2;
  const pX = event.absoluteX - cX;
  const pY = event.absoluteY - cY;
  const tX = pX - activePane.translateX.value * activePane.scale.value;
  const tY = pY - activePane.translateY.value * activePane.scale.value;
  const fX = tX / activePane.scale.value;
  const fY = tY / activePane.scale.value;
  return Math.abs(fX) <= sv.animWidth.value / 2 && Math.abs(fY) <= sv.animHeight.value / 2;
};

export const performZoomToggle = (slot: IPaneSlot) => {
  'worklet';
  if (slot.scale.value > 1) {
    slot.scale.value = withSpring(1, SPRING_CONFIG);
    slot.translateX.value = withSpring(0, SPRING_CONFIG);
    slot.translateY.value = withSpring(0, SPRING_CONFIG);
    slot.lastScale.value = 1;
    slot.baseScale.value = 1;
    slot.lastTranslateX.value = 0;
    slot.lastTranslateY.value = 0;
  } else {
    slot.scale.value = withSpring(2, SPRING_CONFIG);
    slot.lastScale.value = 2;
    slot.baseScale.value = 2;
  }
};
